import dynamic from 'next/dynamic';
import Typography from '@alltrails/core/components/Typography';
import ShimmerContainer from '@alltrails/core/components/ShimmerContainer';
import { SPACE_150 } from '@alltrails/denali/tokens';
import styles from './NlSearchSuggestions.module.scss';

const SwiperCarousel = dynamic(() => import('@alltrails/denali/components/SwiperCarousel'), { ssr: false });

const SuggestionShimmer = () => {
  return (
    <ShimmerContainer className={styles.shimmerContainer}>
      <div className={styles.individualShimmer} />
      <div className={styles.individualShimmer} />
      <div className={styles.individualShimmer} />
    </ShimmerContainer>
  );
};

const NlSearchSuggestion = ({ suggestion, onClick }) => {
  return (
    <button className={styles.searchSuggestion} onClick={onClick}>
      <Typography variant="text200">{suggestion.text}</Typography>
    </button>
  );
};

type NlSuggestionsProps = {
  handleOnAiSearch: (text: string) => void;
  isLoading?: boolean;
  suggestions: { text: string }[];
};

const NlSearchSuggestions = ({ handleOnAiSearch, isLoading, suggestions }: NlSuggestionsProps) => {
  const handleSuggestionClick = (index: number) => {
    const selectedSuggestion = suggestions[index];
    if (selectedSuggestion) handleOnAiSearch(selectedSuggestion.text);
  };

  return (
    <div className={styles.suggestionsContainer}>
      {isLoading ? (
        <SuggestionShimmer />
      ) : (
        <SwiperCarousel
          arrowStyle="subtle"
          items={suggestions}
          renderItem={(suggestion, index) => <NlSearchSuggestion suggestion={suggestion} onClick={() => handleSuggestionClick(index)} />}
          getItemKey={suggestion => (suggestion as { text: string }).text}
          gap={SPACE_150}
          itemsPerGroup="auto"
          itemsPerSlide="auto"
          tabIndex={-1}
          uniqueId="nl-search-suggestions"
          showOverflow
          preventActiveElementBlur
        />
      )}
    </div>
  );
};

export default NlSearchSuggestions;
